import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Loading from "../Loading";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import ContactForm from "../ContactForm";
import SEO from "../SEO";
import { useTranslation } from "react-i18next";
import { useData } from "../../context/DataContext";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn, FaTelegram } from "react-icons/fa";
import { BsTwitterX, BsInstagram } from "react-icons/bs";
import { getImageURL } from "../../api";

function Home() {
  const { t, i18n } = useTranslation();
  const { profile, loading } = useData();
  const lang = i18n.language.split("-")[0];

  const heroTitle =
    profile?.hero?.title?.[lang] || (lang === "uz" ? "Salom!" : "Hi There!");
  const heroName = profile?.hero?.subtitle?.[lang] || "Saidqodirxon Rahim";

  if (loading) {
    return <Loading message="Loading Portfolio..." />;
  }

  return (
    <section>
      <SEO />
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                {heroTitle}{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                {lang === "uz" ? "MEN" : "I'M"}
                <strong className="main-name"> {heroName.toUpperCase()}</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={getImageURL(profile?.hero?.image) || homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 profile={profile} />

      <ContactForm />

      <Container>
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h1>{t("social_networks", "IJTIMOIY TARMOQLAR")}</h1>
            <p>{t("connect_with_me", "Aloqada bo'ling")}</p>
            <ul className="home-about-social-links">
              {profile?.social?.github && (
                <li className="social-icons">
                  <a
                    href={profile.social.github}
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
              )}
              {profile?.social?.twitter && (
                <li className="social-icons">
                  <a
                    href={profile.social.twitter}
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <BsTwitterX />
                  </a>
                </li>
              )}
              {profile?.social?.linkedin && (
                <li className="social-icons">
                  <a
                    href={profile.social.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
              )}
              {profile?.social?.instagram && (
                <li className="social-icons">
                  <a
                    href={profile.social.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <BsInstagram />
                  </a>
                </li>
              )}
              {profile?.contact?.telegram && (
                <li className="social-icons">
                  <a
                    href={profile.contact.telegram}
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <FaTelegram />
                  </a>
                </li>
              )}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
